import React from 'react';
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import createStyles from "@material-ui/core/styles/createStyles";
import Divider from "@material-ui/core/Divider";
import {WithStyles, withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import {injectIntl, InjectedIntlProps} from 'react-intl';
import {ListSubheader} from "@material-ui/core";

import {
  LocalStorageThemePreferences,
  PreferenceModes,
  ThemeSettingsContextProps,
  withThemeSettings
} from '../../../config/ThemeSettingsProvider';

const styles = () => createStyles({
  modeSelector: {
    height: '2rem',
  },
});

interface ThemeSettingsButtonProps extends InjectedIntlProps, WithStyles<typeof styles>, ThemeSettingsContextProps {
}

interface ThemeSettingsButtonState {
  anchorEl: HTMLElement | null;
  currentMode: PreferenceModes | null;
}

const modes = [
  {
    mode: PreferenceModes.AUTO,
    intlKey: 'themePreference.auto',
  },
  {
    mode: PreferenceModes.LIGHT,
    intlKey: 'themePreference.light',
  },
  {
    mode: PreferenceModes.DARK,
    intlKey: 'themePreference.dark',
  }];

class ThemeSettingsButton extends React.Component<ThemeSettingsButtonProps, ThemeSettingsButtonState> {
  constructor(props: ThemeSettingsButtonProps) {
    super(props);
    this.state = {
      anchorEl: null,
      currentMode: null,
    };
  }

  componentDidMount(): void {
    const { getStoredThemePreferences } = this.props;
    const themePreference: LocalStorageThemePreferences = getStoredThemePreferences();
    this.setState({
      currentMode:  themePreference.mode,
    });
  }

  /**
   * @param {void} func - Function used to update theme
   * @param {string} option - The name of the theme
   * @param {string} mode - The mode appearance ("Auto", "Light", "Dark"), with auto being based from OS' Theme
   */
  updateTheme = (func: (value: any) => void, option?: string, mode?: string) => {
    const { getStoredThemePreferences } = this.props;
    const themePreference = getStoredThemePreferences();
    const value = {
      name: option ? option : themePreference && themePreference.name ? themePreference.name : null,
      mode: mode ? mode : themePreference && themePreference.mode ? themePreference.mode : "Auto"
    };
    func(value);
    this.handleClose();
  };

  handleMenu = (event: React.SyntheticEvent<{}, Event>) => {
    //@ts-ignore
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, intl, changeTheme, themeOptions, getStoredThemePreferences  } = this.props;
    const { anchorEl, currentMode } = this.state;
    const open = Boolean(anchorEl);
    const themePreference: LocalStorageThemePreferences = getStoredThemePreferences();
    return (
      <div>
        <IconButton
          aria-owns={open ? 'menu-settingsbar' : undefined}
          aria-haspopup="true"
          onClick={this.handleMenu}
          color="inherit"
        >
          <SettingsIcon />
        </IconButton>
        <Menu
          id="menu-settingsbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={this.handleClose}
          MenuListProps={{
            subheader: <ListSubheader component="div" id="nested-list-subheader">{intl.formatMessage({ id: 'themePreference.titleText' })}</ListSubheader>,
            disablePadding: true,
            dense: true,
          }}
        >
          <Divider />
          { themeOptions.map((option: string) => {
            const selected = themePreference && themePreference.name ? themePreference.name === option : false;
            return (
              <MenuItem
                selected={selected}
                key={option}
                onClick={() => this.updateTheme(changeTheme, option)}
              >
                {option}
              </MenuItem>
            );}
          )}
          <Divider />
          <BottomNavigation
            value={currentMode}
            onChange={(event, newValue) => {
              this.setState({currentMode: newValue}, () => {
                this.updateTheme(changeTheme, null, newValue);
              });
            }}
            showLabels
            className={classes.modeSelector}
          >
            {
              modes.map(({mode, intlKey}) => (
                <BottomNavigationAction
                  key={mode}
                  label={intl.formatMessage({ id: intlKey })}
                  value={mode}
                />
              ))
            }
          </BottomNavigation>
        </Menu>
      </div>
    );
  }
}

export default withStyles(styles)(injectIntl(withThemeSettings(ThemeSettingsButton)));
